import {AssetOperationTimeSource} from '@domain/schedule'
import type {ScheduleItem} from '@domain/schedule'
import {dataTestId} from '@hconnect/uikit'
import {useUpmPlantTimezone} from '@hconnect/upm'
import {AutoAwesome, AccountCircleOutlined} from '@mui/icons-material'
import {Stack, Typography, SvgIconProps} from '@mui/material'
import moment from 'moment-timezone'
import {useTranslation, Trans} from 'react-i18next'

import {PLANNING_SCHEDULE_CHART_WIDGET_NAMESPACE} from '../consts'
import {getLocalizedDayMonthTimeFormat} from '../utils'

export const ScheduleItemUpdatedByInfo = ({
  scheduleItem: {source, updatedBy, updatedOn}
}: {
  scheduleItem: ScheduleItem
}) => {
  const {
    i18n: {language}
  } = useTranslation(PLANNING_SCHEDULE_CHART_WIDGET_NAMESPACE)

  const timezoneId = useUpmPlantTimezone()
  const iconProps: SvgIconProps = {fontSize: 'inherit', sx: {verticalAlign: 'middle'}}

  const formattedDateTime = getLocalizedDayMonthTimeFormat(
    moment.utc(updatedOn),
    timezoneId,
    language
  )

  return (
    <Stack spacing={1} {...dataTestId('schedule_item_updated_by_on_info')}>
      {source === AssetOperationTimeSource.Optimizer ? (
        <>
          <Typography variant="caption">
            <Trans
              ns={PLANNING_SCHEDULE_CHART_WIDGET_NAMESPACE}
              i18nKey="planning.createdByOptimizer"
              components={{1: <AutoAwesome {...iconProps} />}}
            />
          </Typography>
          <Typography variant="caption">
            <Trans
              ns={PLANNING_SCHEDULE_CHART_WIDGET_NAMESPACE}
              i18nKey="planning.acceptedByOn"
              components={{
                1: <AccountCircleOutlined {...iconProps} />
              }}
              values={{name: updatedBy, date: formattedDateTime}}
            />
          </Typography>
        </>
      ) : (
        <Typography variant="caption">
          <Trans
            ns={PLANNING_SCHEDULE_CHART_WIDGET_NAMESPACE}
            i18nKey="planning.lastChangedByOn"
            components={{
              1: <AccountCircleOutlined {...iconProps} />
            }}
            values={{name: updatedBy, date: formattedDateTime}}
          />
        </Typography>
      )}
    </Stack>
  )
}
